var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #e0e4e9;\n      }\n\n      .cls-4 {\n        fill: #637b93;\n      }\n\n      .cls-2 {\n        stroke: #637b93;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 106,
    cy: 81,
    r: 76.54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 153.49,
    y1: 142.91,
    x2: 136.53,
    y2: 142.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.39,142.91c0-10.38-8.42-18.8-18.8-18.8s-18.8,8.42-18.8,18.8h-10.29c-6.21,0-11.25-5.04-11.25-11.25V55.1c0-6.21,5.04-11.25,11.25-11.25H125.28c6.21,0,11.25,5.04,11.25,11.25v87.81h-59.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.46,98.66l-26.76-26.76c-2.11-2.11-4.97-3.3-7.96-3.3h-30.21v74.3h16.96c0-10.38,8.42-18.8,18.8-18.8s18.8,8.42,18.8,18.8h16.96v-28.33c0-5.97-2.37-11.69-6.59-15.91Zm-19.07,2.3l-39.03,.29v-25.81h23.28l18.43,19.19c2.28,2.37,.61,6.31-2.67,6.34Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 143.35,
    y1: 110.32,
    x2: 152.39,
    y2: 110.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.6,156.54c-7.51,0-13.63-6.11-13.63-13.63s6.11-13.63,13.63-13.63,13.63,6.11,13.63,13.63-6.11,13.63-13.63,13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.6,130.28c6.96,0,12.63,5.66,12.63,12.63s-5.66,12.63-12.63,12.63-12.63-5.66-12.63-12.63,5.66-12.63,12.63-12.63m0-2c-8.08,0-14.63,6.55-14.63,14.63s6.55,14.63,14.63,14.63,14.63-6.55,14.63-14.63-6.55-14.63-14.63-14.63h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.29,156.54c-7.51,0-13.63-6.11-13.63-13.63s6.11-13.63,13.63-13.63,13.63,6.11,13.63,13.63-6.11,13.63-13.63,13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.29,130.28c6.96,0,12.63,5.66,12.63,12.63s-5.66,12.63-12.63,12.63-12.63-5.66-12.63-12.63,5.66-12.63,12.63-12.63m0-2c-8.08,0-14.63,6.55-14.63,14.63s6.55,14.63,14.63,14.63,14.63-6.55,14.63-14.63-6.55-14.63-14.63-14.63h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.95,
    y1: 77.69,
    x2: 26.42,
    y2: 77.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.03,
    y1: 87.01,
    x2: 33.5,
    y2: 87.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.56,
    y1: 96.33,
    x2: 27.03,
    y2: 96.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.0e6cadf4b0b4ba8b20100274039e0bf3.svg";
export { ForwardRef as ReactComponent };